import { render, staticRenderFns } from "./ContactMessageBalloon.vue?vue&type=template&id=11ea474c&scoped=true&"
import script from "./ContactMessageBalloon.vue?vue&type=script&lang=js&"
export * from "./ContactMessageBalloon.vue?vue&type=script&lang=js&"
import style0 from "./ContactMessageBalloon.vue?vue&type=style&index=0&id=11ea474c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ea474c",
  null
  
)

export default component.exports